import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Spinner } from '../spinner';
import { comboboxLoadingStateStyles } from './styles/combobox-loading-state.styles';
import type { ComboboxLoadingStatePropsInterface } from './types/combobox-loading-state.types';

/**
 * @since 10.0.0
 */
export const ComboboxLoadingState = forwardRef<HTMLDivElement, ComboboxLoadingStatePropsInterface>(
  (props: ComboboxLoadingStatePropsInterface, forwardedRef) => {
    const { children = <Spinner size="lg" />, className, css: cssProp, ...rest } = props;
    const styles = css(comboboxLoadingStateStyles, cssProp);
    return (
      <div
        ref={forwardedRef}
        data-c11n-component="Combobox.LoadingState"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_combobox__loading-state', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

ComboboxLoadingState.displayName = 'Combobox.LoadingState';
